<script lang="ts">
  import Huebee from 'huebee'
  import 'huebee/huebee.css'
  import { onMount } from 'svelte'

  let {
    id = '',
    value = $bindable(),
    required = false
  } = $props()

  let el, hueb

  onMount(() => {
    hueb = new Huebee(el, {
      notation: 'hex',
    })
    hueb.on('change', function (color, hue, sat, lum) {
      value = color
    })
  })

  function open() {
    hueb.open()
  }

  $effect(() => {
    if (value) {
      hueb?.setColor(value);
    }
  })
</script>

<div>
  <input
    class="form-control"
    {id}
    bind:value={value}
    {required}
    type="text"
    data-lpignore="true"
    bind:this={el}
  />
  <button
    type="button"
    class="colorpicker-trigger"
    onclick={open}
    aria-label="Open color picker"
  >&nbsp;
  </button>
</div>
